<template>
	<div class="workflow">
		<!-- 顶部区域：空间下拉 + tab切换 -->
		<div class="search-bar">
			<div class="search-left">
				<!-- 空间下拉：支持模糊搜索 filterable -->
				<el-select v-model="selectedSpaceId" placeholder="请选择工作空间" style="width:260px" filterable
					@change="handleSpaceChange">
					<el-option v-for="item in workspacesList" :key="item.id" :label="item.name" :value="item.id" />
				</el-select>
			</div>
			<!-- tab切换：智能体 / 工作流 -->
			<el-radio-group v-model="activeTab" @change="handleTabChange">
				<el-radio-button label="agent">智能体</el-radio-button>
				<el-radio-button label="workflow">工作流</el-radio-button>
			</el-radio-group>
		</div>

		<!-- 表格区域 -->
		<div class="content-wrap" style="margin-top:16px">
			<div class="card-grid">
				<div class="project-card" v-for="item in tableData" :key="item.id">
					<!-- 右上角三点下拉菜单 -->
					<el-dropdown trigger="click" @command="(cmd) => handleMenuClick(cmd, item)" class="card-more-wrap">
						<div class="more-btn">
							<i class="el-icon-more" style="transform: rotate(90deg);color: #409EFF;"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="version">版本</el-dropdown-item>
							<el-dropdown-item command="AddLatestVersion"
								>添加最新版本</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<div class="card-title-row">
						<span class="title">{{ item.name||item.workflow_name }}</span>
					</div>
					<p class="card-desc" :title="item.description">{{ item.description||"未描述"}}</p>

					<div class="card-bottom">
						<span class="type-tag">{{ activeTab=="agent"?"智能体":"工作流" }}</span>
						<div class="author-line">
							<div>

								<i v-if="activeTab==='agent'"
									:class="['status-dot', item.is_published ? 'dot-green' : 'dot-gray']"></i>
								<i v-if="activeTab==='workflow'"
									:class="['status-dot', !item.is_published ? 'dot-green' : 'dot-gray']"></i>
							</div>
							<span class="username" v-if="activeTab=='agent'">bot_id:{{ item.id }}</span>
							<span class="username" v-else>workflow_id:{{ item.workflow_id  }}</span>
						</div>
					</div>

					<div class="card-icon">
						<img v-if="item.icon_url" :src="item.icon_url" class="cover-img" />
						<div v-else class="icon-placeholder"></div>
					</div>
					<div class="card-bottom">
						<span style="font-size: 12px;">
							{{formatTsToDate(item.published_at)||formatTsToDate(item.updated_at)||"--"}}</span>
					</div>
				</div>

			</div>
		</div>

		<!-- 分页组件 -->
		<el-pagination style="margin-top:16px;text-align:right" background :current-page="pageNum" :page-size="pageSize"
			:total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
			@current-change="handlePageChange" />
		<el-dialog title="版本列表" :visible.sync="isVersion" width="50%" :append-to-body="true" center>
			<div class="version-dialog-wrap">
				<!-- 表格容器设置最大高度，内部滚动 -->
				<div class="version-table-container">
					<el-table :data="VtableData" border stripe height="100%" style="width:100%">
						<el-table-column label="版本号" prop="version" />
						<el-table-column label="更新时间" prop="created_at">
							<template slot-scope="scope">
								{{formatTsToDate(scope.row.created_at)||"--"}}
							</template>
						</el-table-column>
						<el-table-column label="描述" prop="description" show-overflow-tooltip />
					</el-table>
				</div>

				<!-- 加载更多按钮 -->
				<div v-if="isHasMore" class="more-btn-wrap">
					<el-button type="text" @click="toVersion(arr,'page')">更多</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'workspacesAiList',
		props: {
			// 父组件传入工作空间数组 [{id:"xxx",name:"xxx"},...]
			workspacesList: {
				type: Array,
				default: () => []
			},
			modeKeyId: {
				type: Number,
				default: 0,
			}
		},
		data() {
			return {
				activeTab: 'agent', // 当前tab agent智能体 / workflow工作流
				selectedSpaceId: null,

				// 分页
				pageNum: 1,
				pageSize: 10,
				total: 0,

				tableData: [],
				loading: false,
				VtableData: [], //版本列表
				isVersion: false, //版本弹窗
				isHasMore: false, //版本是否存在下一页+
				arr: {},
				vpageNum: 1,
			}
		},
		watch: {
			// prop数组变化，设置默认选中第一项
			workspacesList: {
				handler(val) {
					this.setDefaultSpace(val)
				},
				immediate: true
			}
		},
		methods: {
			handleMenuClick(cmd, item) {
				console.log('cmd', cmd)
				if (cmd == 'version') {
					this.toVersion(item)
				}
				if (cmd == 'AddLatestVersion' && this.activeTab == 'agent') {
					this.forCozeBotLatest(item)
				}
				if(cmd == 'AddLatestVersion' && this.activeTab == 'workflow'){
					this.forCozeWorkflowsLatest(item)
				}
			},
			async forCozeWorkflowsLatest(item){
				this.arr = item
				try {
					const res = await this.API.get(this.API.fileurl.getCozeWorkflowsLatest, {
						modelKeyId: this.modeKeyId,
						workflowId: this.arr.workflow_id,
					})
				
					if (res?.data?.code === 200) {
						var data = JSON.parse(res.data.data)
						if (data.code === 0) {
							if (data?.data) {
								var bodArr = data.data
								var bodArrString=JSON.stringify(bodArr)
								localStorage.setItem('workflowArr',bodArrString)
								this.$emit("addBot",2)
							}
						}
					} else if (data.code == 4100) {
						if (data.msg == "authentication is invalid") {
							this.$message.error('密钥不存在或过期')
						}
					} else if (data.code == 4101) {
						alert('请开通"getMetadata(Workflow)"权限')
					}
				} catch (e) {
				
				} finally {
				
				}
			},
			async forCozeBotLatest(item) {
				this.arr = item
				try {
					const res = await this.API.get(this.API.fileurl.getCozeBotLatest, {
						modelKeyId: this.modeKeyId,
						botId: this.arr.id,
					})

					if (res?.data?.code === 200) {
						var data = JSON.parse(res.data.data)
						if (data.code === 0) {
							if (data?.data) {
								var bodArr = data.data
								var bodArrString=JSON.stringify(bodArr)
								localStorage.setItem('bodArr',bodArrString)
								this.$emit("addBot",2)
							}
						}
					} else if (data.code == 4100) {
						if (data.msg == "authentication is invalid") {
							this.$message.error('密钥不存在或过期')
						}
					} else if (data.code == 4101) {
						alert('请开通"getMetadata"权限')
					}
				} catch (e) {

				} finally {

				}
			},
			//查看版本
			async toVersion(val, type) {
				this.arr = val
				this.isHasMore = false
				if (!type) {
					this.NextpageNum = ''
					this.vpageNum = 1
					this.VtableData = []
				} else {
					this.vpageNum = this.vpageNum + 1
				}
				try {
					if (this.activeTab === 'agent') {

						// 查询智能体列表，替换为你的真实接口
						const res = await this.API.get(this.API.fileurl.getCozeBotVersionsList, {
							modelKeyId: this.modeKeyId,
							botId: this.arr.id,
							pageNum: this.vpageNum,
							pageSize: 10
						})
						if (res?.data?.code === 200) {
							var data = JSON.parse(res.data.data)
							if (data.code === 0) {
								let list = data?.data?.items || []
								if (list.length > 0) {
									this.isHasMore = data?.data?.has_more || false
									this.VtableData = [...this.VtableData, ...list]
									this.isVersion = true
								}
								console.log('this.VtableData', this.VtableData)
							} else if (data.code == 4100) {
								if (data.msg == "authentication is invalid") {
									this.$message.error('密钥不存在或过期')
								}
							} else if (data.code == 4101) {
								alert('请开通"listVersion(Bot)"权限')
							}
						}
					} else if (this.activeTab === 'workflow') {
						// 查询工作流列表，替换为你的真实接口
						const res = await this.API.get(this.API.fileurl.getCozeWorkflowVersionsList, {
							modelKeyId: this.modeKeyId,
							workflowId: this.arr.workflow_id,
							pageToken: this.NextpageNum,
							pageSize: this.pageSize
						})
						if (res?.data?.code === 200) {
							var data = JSON.parse(res.data.data)
							if (data.code === 0) {
								let list = data?.data?.items || []
								console.log('datadata', data.data)
								if (list.length > 0) {
									this.isHasMore = data?.data?.has_more || false
									if (data?.data?.next_page_token) {
										this.NextpageNum = data.data.next_page_token
									} else {
										this.NextpageNum = ''
									}
									this.VtableData = [...this.VtableData, ...list]
									this.isVersion = true
								}
								console.log('this.VtableData', this.VtableData)


							} else if (data.code == 4100) {
								if (data.msg == "authentication is invalid") {
									this.$message.error('密钥不存在或过期')
								}
							} else if (data.code == 4101) {
								alert('请开通"listWorkflow"权限')
							}
						}
					}

				} catch (e) {

				} finally {

				}


			},
			formatTsToDate(timestamp) {
				if (!timestamp) return ''
				let time = Number(timestamp)
				// 判断是秒级时间戳（10位），转为毫秒
				if (time.toString().length === 10) {
					time = time * 1000
				}
				const date = new Date(time)
				// 补零函数 0~9 → 01、02
				const padZero = n => n < 10 ? '0' + n : n
				const year = date.getFullYear()
				const month = padZero(date.getMonth() + 1) // 月份从0开始
				const day = padZero(date.getDate())
				const hour = padZero(date.getHours())
				const minute = padZero(date.getMinutes())
				const second = padZero(date.getSeconds())
				return `${year}-${month}-${day} ${hour}:${minute}:${second}`
			},
			setDefaultSpace(list) {
				if (list && list.length > 0) {
					this.selectedSpaceId = list[0].id
					this.resetPageAndQuery()
				} else {
					this.selectedSpaceId = null
					this.tableData = []
					this.total = 0
				}
			},

			// 切换Tab：重置页码=1，清空表格，重新查询
			handleTabChange() {
				this.resetPageAndQuery()
			},

			// 切换空间下拉：重置页码=1，清空表格，重新查询
			handleSpaceChange() {
				this.resetPageAndQuery()
			},

			// 重置分页+清空列表，公共方法（切换tab/切换空间都调用）
			resetPageAndQuery() {
				this.pageNum = 1
				this.tableData = []
				this.total = 0
				this.tolist()
			},

			// pageSize改变
			handleSizeChange(val) {
				this.pageSize = val
				this.pageNum = 1
				this.tolist()
			},

			// 页码点击改变
			handlePageChange(val) {
				this.pageNum = val
				this.tolist()
			},

			async tolist() {
				if (!this.selectedSpaceId) {
					this.tableData = []
					this.total = 0
					return
				}
				if (this.modeKeyId === 0) return
				this.loading = true
				try {
					if (this.activeTab === 'agent') {
						// 查询智能体列表，替换为你的真实接口
						const res = await this.API.get(this.API.fileurl.getCozeBotList, {
							modelKeyId: this.modeKeyId,
							spaceId: this.selectedSpaceId,
							pageNum: this.pageNum,
							pageSize: this.pageSize
						})
						if (res?.data?.code === 200) {
							var data = JSON.parse(res.data.data)
							if (data.code === 0) {
								this.tableData = data?.data?.items || []
								this.total = data?.data?.total || 0
							} else if (data.code == 4100) {
								if (data.msg == "authentication is invalid") {
									this.$message.error('密钥不存在或过期')
								}
							} else if (data.code == 4101) {
								alert('请开通"listBot"权限')
							}

						}
					} else if (this.activeTab === 'workflow') {
						// 查询工作流列表，替换为你的真实接口
						const res = await this.API.get(this.API.fileurl.getCozeWorkflowList, {
							modelKeyId: this.modeKeyId,
							spaceId: this.selectedSpaceId,
							pageNum: this.pageNum,
							pageSize: this.pageSize
						})
						if (res?.data?.code === 200) {
							var data = JSON.parse(res.data.data)
							if (data.code === 0) {
								this.tableData = data?.data?.items || []
								if (data?.data?.has_more) {
									this.total = this.pageNum * this.pageSize + 1
								} else {
									this.total = (this.pageNum - 1) * this.pageSize + this.tableData.length
								}

							} else if (data.code == 4100) {
								if (data.msg == "authentication is invalid") {
									this.$message.error('密钥不存在或过期')
								}
							} else if (data.code == 4101) {
								alert('请开通"listWorkflow"权限')
							}
						}
					}
				} catch (err) {
					console.error('查询列表异常', err)
				} finally {
					this.loading = false
				}
			}
		},
		created() {
			// workspacesList watch immediate会触发 setDefaultSpace → resetPageAndQuery → tolist，这里不用写
		}
	}
</script>

<style scoped>
	.workflow {
		padding: 20px;
		background-color: #fff;
	}

	.search-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.search-left {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.card-grid {
		/* 卡片最小宽度200px，自动填充列 */
		display: grid;
		grid-template-columns: repeat(auto-fill, 300px);
		gap: 16px;
	}

	.project-card {
		overflow: hidden;
		min-height: 160px;
		background:
			radial-gradient(circle at 94% 12%, rgba(64, 158, 255, .12), transparent 28%),
			linear-gradient(135deg, #ffffff 0%, #f8fbff 56%, #eef7ff 100%);
		border-radius: 16px;
		padding: 14px 14px 14px;
		border: 1px solid rgba(126, 154, 186, .16);
		box-shadow: 0 12px 30px rgba(31, 65, 105, .08);
		transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
		position: relative;
	}

	.project-card:hover {
		transform: translateY(-3px);
		background:
			radial-gradient(circle at 94% 12%, rgba(64, 158, 255, .16), transparent 28%),
			linear-gradient(135deg, #ffffff 0%, #f8fbff 56%, #eef7ff 100%);
		box-shadow: 0 18px 44px rgba(31, 65, 105, .13);
		border-color: rgba(64, 158, 255, .28);
	}

	/* 右上角下拉容器定位 */
	.card-more-wrap {
		position: absolute;
		right: 10px;
		bottom: 10px;
		z-index: 5;
	}

	.more-btn {
		width: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
		cursor: pointer;
		opacity: 0;
		transition: opacity .2s;
		background: rgba(255, 255, 255, .88);
		box-shadow: 0 8px 18px rgba(31, 65, 105, .1);
	}

	/* 卡片hover时展示三点按钮 */
	.project-card:hover .more-btn {
		opacity: 1;
	}

	.more-btn:hover {
		background: #f1f1f1;
	}

	.card-title-row {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 16px;
		font-weight: 700;
		margin-bottom: 6px;
		color: #172033;
		/* 给右上角图标留出更小空间 */
		padding-right: 70px;
	}

	.card-desc {
		font-size: 13px;
		color: #667085;
		line-height: 1.55;
		margin-bottom: 10px;
		height: 60px;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
		max-width: calc(100% - 70px);
		word-wrap: break-word;
		word-break: break-all;
	}

	.card-bottom {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.type-tag {
		font-size: 11px;
		background: rgba(47, 128, 237, .1);
		color: #2f80ed;
		padding: 3px 7px;
		border-radius: 999px;
		font-weight: 700;
		width: fit-content;
	}

	.author-line {
		font-size: 11px;
		color: #6b7280;
		display: flex;
		gap: 4px;
		align-items: center;
	}

	.username {
		display: inline-block;
		max-width: 100px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.card-icon {
		position: absolute;
		right: 12px;
		top: 12px;
		/* 缩小右上角图标，适配200px卡片 */
		width: 60px;
		height: 60px;
		border-radius: 12px;
		overflow: hidden;
		border: 1px solid rgba(255, 255, 255, .8);
		box-shadow: 0 10px 22px rgba(31, 65, 105, .14);
	}

	.cover-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.icon-placeholder {
		width: 100%;
		height: 100%;
		background: #f1f5f9;
	}

	.load-tip {
		text-align: center;
		padding: 16px 0;
		font-size: 13px;
		color: #9ca3af;
	}

	.load-tip.no-more {
		color: #6b7280;
	}

	@media (max-width: 1100px) {
		.card-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	@media (max-width: 650px) {
		.card-grid {
			grid-template-columns: 1fr;
		}
	}

	.status-dot {
		display: inline-block;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		margin-right: 4px;
	}

	.dot-green {
		background-color: #67c23a;
	}

	.dot-gray {
		background-color: #909399;
	}

	.version-dialog-wrap {
		display: flex;
		flex-direction: column;
		/* 弹窗内容区域占视窗80%高度 */
		max-height: 80vh;
	}

	.version-table-container {
		flex: 1;
		overflow: hidden;
	}

	.more-btn-wrap {
		text-align: center;
		padding: 12px 0 4px;
	}
</style>